import {
  hasImportableDiscoveredModelsV816,
  isSuccessfulModelDiscoverySourceV816,
} from './channelModelDiscoveryV816';

export function isInformationalModelDiscoverySourceV93(source) {
  return (
    isSuccessfulModelDiscoverySourceV816(source) ||
    source === 'reference_catalog' ||
    source === 'supported_static'
  );
}

export function canClearDelistedModelsV93(data) {
  return (
    isSuccessfulModelDiscoverySourceV816(data?.source) &&
    hasImportableDiscoveredModelsV816(data)
  );
}

export function applyDiscoveredModelImportV93(current, discovered, source) {
  return source === 'reference_catalog' || source === 'supported_static'
    ? Array.from(new Set([...current, ...discovered]))
    : discovered;
}
